<template>
	<div id="transcriptsDashboard" class="row no-bottom-margin grey lighten-5">
		<div class="loader-container" v-if="!ready || loading">
				<div 
				class="preloader-wrapper small active">
				<div class="spinner-layer spinner-blue-only">
				<div class="circle-clipper left">
					<div class="circle"></div>
				</div><div class="gap-patch">
					<div class="circle"></div>
				</div><div class="circle-clipper right">
					<div class="circle"></div>
				</div>
				</div>
				</div>
			</div>
		<div id="eStateHolder" v-else-if="ready && items.length < 1">
			<empty-state
        :show-button="true">
				<template #header>{{timeOfDay}} {{user.name}}</template>
				<template #content>
					<div>
						There's currently have no pending requests. Check back sometime later
					</div>
				</template>
				<template #action>
          &nbsp;
				</template>
			</empty-state>
		</div>
			<div class="col s12 " >    
          <div class="col s12  site-max listing-view" >
            <div class="col s12">
							<search-field @search="$_searchFilter($event)" class="left" style="width: 100%"/>
            <div class="clear"></div>
					<!-- 	<div class="page-meta">Transcript Requests</div> -->
						</div>
						<div class="col s12 m4 textCaps" v-show="items.length > 0">
							<select-field
									class="left "
									:show-label="true"
									data-source="code"
									@update="filterBy = $event.values"
									:data-options="{
										icon: {
											active: false,
											value: 'sort'
										},
										v: true,
										type: 'select',
										label: 'Filter By Statis',
										values: 'none',
										propName: 'status',
										options: ['none','not-started', 'on-hold', 'complete', 'pending']
									}"
								>
								<span></span>
							</select-field>
						</div>
						<div class="col input-field right right-align">
								<router-link  :to="{path:'/coa-transcript-request'}"  class="btn waves-effect rounded right white-text"> <i class="material-icons left white-text">launch</i>Add Request</router-link>
						</div>
						<div style="width:100%; height:1px; clear:both;"></div>
						<div class="row flex wrap-items" style="padding: 12px;">
							<div class="col s12 m4" v-for="item in mappedItems" :key="item.id">
								<div class="card hoverable">
									<div class="card-content">
										<div class="card-title" v-html="item.case_name"></div>
										<div class="recieved-date">{{$_formatDate(item.date, 'Do, MMMM, YY hh:mm a')}}</div>
										<span class="requesting-party chip" v-text="item.requesting_party"></span>
										<span class="card-email chip grey-text text-darken-4 grey lighten-4">Email: {{item.email}}</span>
										<span class="chip" v-text="`Case #: `+item.case_number"></span>
										<div class="card-dates">
											
												<span  class="chip blue-text text-accent-4 grey lighten-4 left" v-for="(date, idx) in item.hearing_dates" :key="idx">
												{{date.notes}}
												</span>
											
										</div>
									</div>
                <div class="card-action">
									<router-link :to="{name:'itemView', params:{id:item.id}}" class="btn-flat indigo-text text-accent-3 waves-effect">View</router-link>
									<button @click="$_deleteRecord(item.id)" class="btn-floating btn-flat btn-small right waves-effect transparent"><i class="material-icons-outlined grey-text text-darken-3">delete</i></button>
									<div class="clear"></div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col s12">
								<div class="card">
									<div class="card-content">

										<table>
											<thead>
												<tr>
													<th>Case Name</th>
													<th>Case Number</th>
													<th>Date Submited</th>
													<th>Requesting Party</th>
													<th>Email</th>
													<th>Staus</th>
												</tr>
											</thead>
									<tbody>
										<tr v-for="(item, index) in mappedItems" :key="index">
											<td>
												<div class="title" v-html="item.case_name"></div>
											</td>
											<td><span class="" v-text="`Case #: `+item.case_number"></span></td>
											<td>
												<div class="recieved-">{{$_formatDate(item.date, 'Do, MMMM, YY hh:mm a')}}</div>
											</td>
											<td>
												
												<span v-text="item.requesting_party"></span>
											</td>
											<td>
										<span class="card-email">Email: {{item.email}}</span></td>
										<td>
											Pending
										</td>
										</tr>
									</tbody>
								</table>
									</div>
								</div>
							</div>
						</div>
            <div class="clear"></div>
          </div>
			</div>
	
		<div class="pickers" id="pickerContainer">
			
		</div>
		<!-- diglog  Modal -->
    <div class="dialog" ref="dialogComponent"></div>
    <!-- block list Modal -->
		<router-view @delete="$_removeCompleted" :list-items="mappedItems" />
	</div>
</template>
<script>
import core from '@/functions'
import ticketService from '@/services/ticketService'
import dialogComponent from '@/components/dialog.component'
import searchField from '@/components/searchField.component'
import estate from '@/assets/estate.svg'
import Vue from 'vue'
import { mapState } from 'vuex'
import selectField from "@/components/editing/selectField.component"
import emptyState from '@/components/emptyState.component'
export default {
	name: 'requestList',
	components: {
		emptyState,
		selectField,
		searchField,
		// eslint-disable-next-line vue/no-unused-components
		dialogComponent,
	},
	data () {
		return {
			estate,
			filterBy:'none',
			searchFilter: '',
      items: [],
			loading: false,
			ready:false,
			pagination: {
        page: 1,
        per: 20
      }
		};
	},
	mounted() {
    this._fetchRequests()
	},
	computed: {
		...mapState({
			user: state => state.user,
		/* 	authUser: state => state.authUser,
			users:state=> state.record.users,
			companies:state=> state.record.companies */
		}),
		currentRoute:{
			get(){
				return this.$route.name
			}
		},
		mappedItems : {
			get () {
        return this.items.map(x => {
          return {
            id:x.id, source_address: x.author_ip, date:x.date,  ...JSON.parse(x.content.raw)
          }
        })
						
			}
		},
		timeOfDay: function() {
			let today = new Date();
			let curHr = today.getHours();
			if (curHr < 12) {
				return "Good Morning";
			} else if (curHr < 18) {
				return "Good Afternoon";
			} else {
				return "Good Evening";
			}
		},
	},
	watch:{
		$route:function(nV){
			if(nV && nV.name === 'records') {
	/* 
			this.$_getCompanies()
			this.$_fetchUsers() */
			}
		
		}
	},
	methods: {
		$_removeCompleted(id) {
			this.deleteItem(id)
		},
    _fetchRequests(){
      ticketService.getComments(3431)
      .then(x => {
        this.items = x.data
				this.ready = true
      })
      .catch(err => {
        window.console.log(err)
      })
    },
		$_searchFilter($event) {
			this.searchFilter = $event
		},
		statusColor(s){
		return s === 'not-started'
				? 'indigo accent-4'
				: s === 'on-hold'
					? 'yellow darken-2 brown-text'
					: s === 'pending'
						? 'yellow darken-2 grey-text text-darken-3'
						: s === 'complete'
							? 'green accent-4'
							: 'red white-text'
		},
		$_formatDate(date, format){
			return core.dateFormat(new Date(date), format)
    },
		deleteItem (id) {
			this.loading = true
			ticketService.deleteComment(id)
			.then(() => {
				this._fetchRequests()
				this.loading = false
			})
		},
		dialogMessages(data) {
      let ComponentClass = Vue.extend(dialogComponent);
      let instance = new ComponentClass({
        propsData: data
      });
      let link = instance.$createElement("div", {
        attrs: {
          class: "context"
        },
        domProps: {
          innerHTML: data.message
        }
      });

      instance.$slots.default = [link];
      instance.$slots["title"] = [data.title];
      instance.$mount(); // pass nothing
      this.$refs.dialogComponent.appendChild(instance.$el);
    },
		$_deleteRecord(id){
		let data = {
				title:'Delete Request',
        message: "Are you sure you want to delete this request?",
        buttons: [
          {
            id: 0,
            value: "cancel",
            action: () => {},
            close: true
          },
   
          {
            id: 2,
            value: "Delete",
            action: () => {
							this.deleteItem(id)
            },
            close: true
          }
        ]
      };
			this.dialogMessages(data);
		},
	}
};
</script>
<style scoped lang="scss">
div#transcriptsDashboard {
	min-height: calc(100vh - 68px);
	position: relative;
	@media screen and (min-width: 1024px) {
		width: 100%;
		padding-left: 300px;
	}
	#eStateHolder {
		left: 50%;
		top: 50%;
		position: absolute;
		transform: translate(-50%, -50%);
		@media screen and (min-width: 1024px) {
			transform: translate(calc(-50% + 150px), -50%);
		}
	}
	.title-section {
		font-size: 24px;
		line-height: 1.5;
		margin: 12px 0px 12px 0px;
	}
	.page-meta {
		font-size: 24px; 
		line-height: 1.3;
		margin: .75rem 0;
	}
	.clearbtn {
    position: absolute;
    right: 9px;
    top: 16px;
    cursor: pointer;
			i {
        font-size: 18px;
      }
  }
	
	.tsc {
		position: relative;
		&::before {
			content: "search";
			font-family: "Material Icons";
			font-size: 21px;
			position: absolute;
			top: 10px;
			color: #8f8f8f;
			left: 12px;
		}
	}
	.circle-tar {
		border-radius:50%;
		width:50px;
		height:50px;
	}
button.btn.cs-btn {
    padding: 0px 4px;
    height: 30px;
    line-height: 29px;
    margin-right: 5px;
}
.loader-container {
		position: fixed;
		top:50%;
		left:50%;
		transform:translate(-50%,-50%);
			@media screen and (min-width:1024px){
				left:calc(50% + 300px);
				transform:translate(calc(-50% - 250px),-50%);
			}
	}
  .listing-view {
    margin-top:24px;
  }
  .card {
    border-radius: 8px;
    overflow: hidden;
		height: calc(100% - 1.5rem);
		padding-bottom:64px;
		.card-content {
			padding: 24px 24px 12px 24px;
			ul {
				margin: 0px;
			}
		}
		.card-title {
			font-size: 20px;
			line-height: 1.2;
			font-weight:400;
			margin: 0px 0 12px 0;
		}
	.card-dates {
		width: 100%;
		clear: both;
	}
    .card-action {
      padding:0px 24px 24px;
			border-top:none;
			position: absolute;
			bottom: 0; left: 0; right: 0;
    }
    blockquote {
      font-size: 13px;
      padding-left: 8px;
      border-left: 4px solid #304ffe;
			letter-spacing: 1px;
      margin: 7px 2px;
    }
  }
  .date-recieved {
    font-size:12px;
  }
	.badge {
		text-transform: capitalize;
	}
}
.recieved-date {
    font-size: 14px;
    margin-bottom: 12px;
    font-weight: 500;
		&::before {
		content: 'Submited On: ';
		}
}

</style>
<style lang="scss">
	.textCaps, .textCaps input.select-dropdown.dropdown-trigger {
		text-transform: capitalize !important;
	}
</style>